import {Popover, PopoverChevron, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {RosterPopoverTrigger} from '@/components';
import {SellerAvatarStack, SellersRosterPopoverContent} from '@/features/trust-accounts/components';

import type {TrustSellerDetailsDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface TrustAccountSellersHeaderControlProps {
  sellers: TrustSellerDetailsDTO[];
}

export const TrustAccountSellersHeaderControl: FC<TrustAccountSellersHeaderControlProps> = ({
  sellers
}) => {
  const {t} = useTranslation('trustAccounts');
  const countLabel = t('columns.sellersCount', {count: sellers.length});

  return (
    <Popover>
      <RosterPopoverTrigger className="gap-2 rounded-md px-2 py-1 hover:bg-background-surface_hover hover:ring-1 hover:ring-border hover:ring-inset">
        <SellerAvatarStack sellers={sellers} size="xs" />
        <Typography size="xs" color="secondary">
          {countLabel}
        </Typography>
        <PopoverChevron width={14} height={14} />
      </RosterPopoverTrigger>
      <SellersRosterPopoverContent
        sellers={sellers}
        title={t('view.header.sellersPopover.title')}
      />
    </Popover>
  );
};
